import { render, staticRenderFns } from "./DeleteToolbar.vue?vue&type=template&id=fb5473aa&"
import script from "./DeleteToolbar.vue?vue&type=script&lang=ts&"
export * from "./DeleteToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports